import type { QueryRowType } from "@rocicorp/zero";
import { queries } from "../../../shared/queries";
import type { GrantEntry } from "../../../shared/rbac/roles";
import { useConnectorDisconnectGuard } from "../../hooks/useConnectorDisconnectGuard";
import { useQuery } from "../../hooks/useQuery";
import { connectorRoleDefaultsForSpace } from "../../lib/connectorGrantsForSpace";
import type { ScopeAccessPendingHandle } from "../ScopeAccessTable";
import { SupplierAccessTab } from "../SupplierAccessTab";

type Connector = NonNullable<
  QueryRowType<ReturnType<typeof queries.loadConnectedApp>>
>;

type Props = {
  app: Connector;
  canManage: boolean;
  stagedGrantsRef?: { current: ScopeAccessPendingHandle | null };
  onEdit?: () => void;
  localGrants?: GrantEntry[];
  onChangeLocalGrants?: (grants: GrantEntry[]) => void;
  newPrincipalIds?: ReadonlySet<string>;
};

export function AccessTab({
  app,
  canManage,
  stagedGrantsRef,
  onEdit,
  localGrants,
  onChangeLocalGrants,
  newPrincipalIds,
}: Props) {
  const [groupAccess] = useQuery(
    queries.connectedAppGroupAccess({ connectedAppId: app.id })
  );
  const { guardCommit, modal: guardModal } = useConnectorDisconnectGuard({
    appId: app.id,
    appName: app.name,
    scopeGrants: app.roleGrantsAsScope,
  });
  return (
    <SupplierAccessTab
      scopeId={app.id}
      scopeKind="connected_app"
      scopeGrants={app.roleGrantsAsScope}
      supplierRelation="space_uses_connected_apps"
      roleDefaultsForSpace={connectorRoleDefaultsForSpace}
      resourceLabel="connector"
      accessDescription="Add members and groups, and choose their role."
      groupAccess={groupAccess}
      canManage={canManage}
      onEdit={onEdit}
      stagedGrantsRef={stagedGrantsRef}
      localGrants={localGrants}
      onChangeLocalGrants={onChangeLocalGrants}
      newPrincipalIds={newPrincipalIds}
      guardCommit={guardCommit}
      guardModal={guardModal}
    />
  );
}
